import { memo } from 'react'
import BaseReportTable from './BaseReportTable'
import { DEFAULT_ROWS } from '../constants'

function InvoiceWiseTable({
  columns,
  rows,
  loading,
  pagination,
  sortBy,
  sortOrder,
  onSort,
  onOpenInvoice,
}) {
  return (
    <BaseReportTable
      columns={columns}
      rows={rows}
      loading={loading}
      limit={pagination.limit || DEFAULT_ROWS}
      emptyMessage="No invoices found"
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      getRowKey={(row) => row.orderId}
      onRowClick={(row) => onOpenInvoice(row.orderId)}
    />
  )
}

export default memo(InvoiceWiseTable)
